import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { getBulkErrorCause } from '../utils/get-bulk-error-cause';

export const useHandleSaveError = () => {
  const { t } = useTranslation('bulk-messaging');
  const alert = useAlert();

  const handleSaveError = useCallback(
    (error: unknown, defaultErrorMessage = t('An unexpected error occurred. Please try again or contact support.')) => {
      const errorMessage = getBulkErrorCause(error) ?? (error instanceof Error ? error.message : undefined);
      if (errorMessage) {
        alert.error(t('An unexpected error occurred: {{errorMessage}}', { errorMessage }));
      } else {
        alert.error(defaultErrorMessage);
      }
    },
    [alert, t]
  );

  return { handleSaveError };
};
